"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.fetchEmbedLy = exports.useEmbedLy = void 0;
/* eslint-disable canonical/id-match */
// Need to disable this rule to match with embedly library
const lodash_1 = require("lodash");
const react_1 = require("react");
const fetchEmbedLy_1 = require("./utils/fetchEmbedLy");
const useEmbedLy = (value, { apiUrl, autoplay, chars, delay = 500, filterUrls, key, maxHeight, regex, scheme, types, }) => {
    const abortControllerRef = (0, react_1.useRef)(null);
    const [response, setResponse] = (0, react_1.useState)(null);
    const [isLoading, setIsLoading] = (0, react_1.useState)(false);
    const handleRequest = (0, react_1.useCallback)((handleRequestValue) => {
        var _a;
        setIsLoading(true);
        (_a = abortControllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
        const { controller, fetchPromise } = (0, fetchEmbedLy_1.fetchEmbedLy)(handleRequestValue, {
            apiUrl,
            autoplay,
            chars,
            filterUrls,
            key,
            maxHeight,
            scheme,
            types,
            urlRegex: regex,
        });
        abortControllerRef.current = controller;
        fetchPromise
            .then((res) => {
            setResponse(res);
        })
            .catch(() => setResponse(null))
            .finally(() => setIsLoading(false));
    }, [apiUrl, autoplay, chars, filterUrls, key, maxHeight, regex, scheme, types]);
    const debouncedHandleRequest = (0, react_1.useMemo)(() => (0, lodash_1.debounce)(handleRequest, delay), [delay, handleRequest]);
    (0, react_1.useEffect)(() => {
        debouncedHandleRequest(value);
    }, [debouncedHandleRequest, value]);
    return { isLoading, response };
};
exports.useEmbedLy = useEmbedLy;
var fetchEmbedLy_2 = require("./utils/fetchEmbedLy");
Object.defineProperty(exports, "fetchEmbedLy", { enumerable: true, get: function () { return fetchEmbedLy_2.fetchEmbedLy; } });
//# sourceMappingURL=index.js.map